import React from 'react';
import Layout from '../../Components/Layout';
import ProductShow from '../../Components/ProductsShow';

const ProductShowCase = () => {
    return (
        <Layout>
            <ProductShow/>
        </Layout>
    );
};

export default ProductShowCase;